/* MindCoco — Bundle PIN6 STI2 Selector
   Handle: bundle-pin6-sti2
   Logic: pick 6 PINs (from 40 curated) + 2 STIs (from 19, or blind box)
*/
window.MC_BUNDLE_VARIANT_ID = 53602551267642;
window.MC_BUNDLE_DEFAULT_IMG = 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI_PDP-P3.png?v=1781611032';
// Theme handles body visibility — do not interfere
(function () {
  'use strict';

  if (!document.querySelector('.mc-bundle-wrap')) return;

  var ALL_VARIANTS =
    [
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50172809707834",
          "sku": "4000999PIN_029"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50172820160826",
          "sku": "4000999PIN_019"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50240442466618",
          "sku": "4000999PIN_047"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50281313894714",
          "sku": "4000999PIN_048"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286560182586",
          "sku": "4000999PIN_010"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286569292090",
          "sku": "4000999PIN_024"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286575092026",
          "sku": "4000999PIN_001"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286582989114",
          "sku": "4000999PIN_005"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286590492986",
          "sku": "4000999PIN_006"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286595998010",
          "sku": "4000999PIN_046"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286612021562",
          "sku": "4000999PIN_007"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286722187578",
          "sku": "4000999PIN_003"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286723957050",
          "sku": "4000999PIN_016"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286724251962",
          "sku": "4000999PIN_013"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286729199930",
          "sku": "4000999PIN_017"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286730838330",
          "sku": "4000999PIN_015"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286731329850",
          "sku": "4000999PIN_012"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50286752858426",
          "sku": "4000999PIN_050"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50295317365050",
          "sku": "4000999PIN_014"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50310990299450",
          "sku": "4000999PIN_020"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50418419171642",
          "sku": "4000999PIN_025"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50418449285434",
          "sku": "4000999PIN_023"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50418457608506",
          "sku": "4000999PIN_036"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50418462916922",
          "sku": "4000999PIN_021"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50438458835258",
          "sku": "4000999PIN_027"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50438459982138",
          "sku": "4000999PIN_028"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50438461653306",
          "sku": "4000999PIN_030"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50438463815994",
          "sku": "4000999PIN_032"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50438465552698",
          "sku": "4000999PIN_033"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50438467715386",
          "sku": "4000999PIN_034"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50438469026106",
          "sku": "4000999PIN_035"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50474604462394",
          "sku": "4000999PIN_037"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50474651222330",
          "sku": "4000999PIN_038"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50474665902394",
          "sku": "4000999PIN_043"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50474672357690",
          "sku": "4000999PIN_044"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50512197878074",
          "sku": "4000999PIN_042"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50512233201978",
          "sku": "4000999PIN_041"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50512340418874",
          "sku": "4000999PIN_052"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50512344088890",
          "sku": "4000999PIN_053"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50512351953210",
          "sku": "4000999PIN_054"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50512403759418",
          "sku": "4000999PIN_055"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50673220157754",
          "sku": "4000999PIN_058"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50673483481402",
          "sku": "4000999PIN_059"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50674786402618",
          "sku": "4000999PIN_066"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50674818220346",
          "sku": "4000999PIN_064"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50675023774010",
          "sku": "4000999PIN_069"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50779773829434",
          "sku": "4000999PIN_065"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50779780088122",
          "sku": "4000999PIN_067"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50780043608378",
          "sku": "4000999PIN_068"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50780208824634",
          "sku": "4000999PIN_049"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50780220096826",
          "sku": "4000999PIN_074"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/50780232745274",
          "sku": "4000999PIN_009"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51172445454650",
          "sku": "4000999PIN_076"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51172453089594",
          "sku": "4000999PIN_077"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51172467900730",
          "sku": "4000999PIN_078"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51172495687994",
          "sku": "4000999PIN_080"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51396066607418",
          "sku": null
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51396066640186",
          "sku": null
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51396066672954",
          "sku": null
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51566027178298",
          "sku": "4000999PIN_082"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51566381367610",
          "sku": "4000999PIN_084"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51566391263546",
          "sku": "4000999PIN_085"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51738868711738",
          "sku": "4000999PIN_086"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51741154902330",
          "sku": "4000999PIN_087"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51741250552122",
          "sku": "4000999PIN_089"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51776704971066",
          "sku": "4000999PIN_091"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51776738230586",
          "sku": "4000999PIN_093"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51776742687034",
          "sku": "4000999PIN_092"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51776752222522",
          "sku": "4000999PIN_094"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51824678142266",
          "sku": "4000999PIN_095"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51825233887546",
          "sku": "4000999PIN_097"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51825236738362",
          "sku": "4000999PIN_098"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51825241751866",
          "sku": "4000999PIN_099"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51925302149434",
          "sku": "4000999PIN_100"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51952114893114",
          "sku": "4000999PIN_103"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51952123576634",
          "sku": "4000999PIN_104"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/51998822793530",
          "sku": "4000999PIN_105"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52005651579194",
          "sku": "4000999PIN_107"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52073174401338",
          "sku": "4000999PIN_108"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52111316255034",
          "sku": "4000999PIN_110"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52165310382394",
          "sku": "4000999PIN_111"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52165324276026",
          "sku": "4000999PIN_112"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52196189962554",
          "sku": "4000999PIN_113"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52196510826810",
          "sku": "4000999PIN_115"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52534031941946",
          "sku": "4000999PIN_116"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52534859039034",
          "sku": "4000999PIN_117"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52534865297722",
          "sku": "4000999PIN_118"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52547370680634",
          "sku": "4000999PIN_119"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52547462529338",
          "sku": "4000999PIN_120"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52574897799482",
          "sku": "4000999PIN_121"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52574902878522",
          "sku": "4000999PIN_122"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52618088448314",
          "sku": "4000999PIN_125"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52618146873658",
          "sku": "4000999PIN_124"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52882422595898",
          "sku": "7000999STI_004"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52918935585082",
          "sku": "7000999STI_098"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52942430142778",
          "sku": "7000999STI_001"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52942432993594",
          "sku": "7000999STI_006"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52942455374138",
          "sku": "7000999STI_007"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52945884873018",
          "sku": "7000999STI_008"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52947284164922",
          "sku": "7000999STI_010"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/52968354545978",
          "sku": "3000833BOOK_WHT"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53002429137210",
          "sku": "7000999STI_013"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53002465345850",
          "sku": "7000999STI_011"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53002498310458",
          "sku": "7000999STI_009"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53004380668218",
          "sku": "7000999STI_005"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53013951709498",
          "sku": "7000999STI_014"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53095224803642",
          "sku": "4000999PIN_126"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53095226736954",
          "sku": "4000999PIN_127"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53095261339962",
          "sku": "4000999PIN_129"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53095264846138",
          "sku": "4000999PIN_128"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53199479636282",
          "sku": "7000999STI_012"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53199490711866",
          "sku": "7000999STI_015"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53199591473466",
          "sku": "7000999STI_016"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53243091779898",
          "sku": "4000999PIN_130"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53247911199034",
          "sku": "4000999PIN_131"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53247934955834",
          "sku": "4000999PIN_132"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53247956943162",
          "sku": "4000999PIN_133"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53283673768250",
          "sku": "4000999PIN_136"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53288216953146",
          "sku": "4000999PIN_134"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53288608203066",
          "sku": "4000999PIN_135"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53361264001338",
          "sku": "4000999PIN_137"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53361317839162",
          "sku": "4000999PIN_147"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53361326293306",
          "sku": "4000999PIN_142"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53361341137210",
          "sku": "4000999PIN_141"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376089686330",
          "sku": "4000999PIN_139"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376090505530",
          "sku": "4000999PIN_140"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376092635450",
          "sku": "4000999PIN_143"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376094011706",
          "sku": "4000999PIN_144"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376096010554",
          "sku": "4000999PIN_145"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376096796986",
          "sku": "4000999PIN_146"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376097255738",
          "sku": "4000999PIN_148"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376098730298",
          "sku": "4000999PIN_149"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376099746106",
          "sku": "4000999PIN_150"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53376100630842",
          "sku": "4000999PIN_151"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53410392604986",
          "sku": "4000999PIN_138"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53410457485626",
          "sku": "7000999STI_017"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53410457518394",
          "sku": "7000999STI_020"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53461605482810",
          "sku": "7000999STI_018"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53462156837178",
          "sku": "7000999STI_019"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53564872327482",
          "sku": "7000999STI_003"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53602543141178",
          "sku": "4000999PIN_152"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53602551267642",
          "sku": "BUNDLE-PIN6-STI2"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53628954673466",
          "sku": "7000999STI_SURPRISE1"
        }
      },
      {
        "node": {
          "id": "gid://shopify/ProductVariant/53628966109498",
          "sku": "7000999STI_SURPRISE2"
        }
      }
    ]

  // ── PIN DATA (Top 40 by sales, grouped) ──────────────────────
  var PIN_DATA = [
    // group, label (short), full title key in image map, sku
    { g: 'zero-fucks', label: 'Society of Badass Women',        img: '"Society of Badass Women" \u2013 Women\'s Solidarity',           sku: '4000999PIN_038' },
    { g: 'zero-fucks', label: 'Daily Shitstorm Survivors Club', img: 'PIN_098_Daily_Shitstorm',   sku: '4000999PIN_098' },
    { g: 'zero-fucks', label: 'OH, LOOK! NOBODY GIVES A SHIT', img: '"OH, LOOK! NOBODY GIVES A SHIT" \u2013 Zero F\'s Given',         sku: '4000999PIN_136' },
    { g: 'zero-fucks', label: 'Just About McFuckin Had It',     img: 'PIN_127_McFuckin',                                               sku: '4000999PIN_127' },
    { g: 'zero-fucks', label: 'SHENANIGAN ENTHUSIAST',          img: '"SHENANIGAN ENTHUSIAST" \u2013 Mood Badge',                      sku: '4000999PIN_147' },
    { g: 'zero-fucks', label: "Didn't Lose My Sh*t Today",      img: '"Didn\'t Lose My Sh*t Today" \u2013 Coping Win',                 sku: '4000999PIN_023' },
    { g: 'zero-fucks', label: 'I Tried',                        img: '"I Tried" \u2013 Low Effort Win',                                sku: '4000999PIN_052' },
    { g: 'zero-fucks', label: 'Gotta Be Dramatic First',        img: '"Gotta Be Dramatic First" \u2013 Drama Energy',                  sku: '4000999PIN_030' },

    { g: 'brain', label: 'Get Sh!t Done Club',               img: '"Get Sh!t Done Club" \u2013 ADHD Productivity',                  sku: '4000999PIN_064' },
    { g: 'brain', label: 'Doom Pile',                         img: '"Doom Pile" \u2013 Doom Stack Life',                             sku: '4000999PIN_133' },
    { g: 'brain', label: 'Easily Distracted by Shiny Things', img: '"Easily Distracted by Shiny Things" \u2013 Shiny Thing Distraction', sku: '4000999PIN_108' },
    { g: 'brain', label: 'Can You Repeat?',                   img: '"Can You Repeat?" \u2013 Brain Fog',                             sku: '4000999PIN_044' },
    { g: 'brain', label: 'My Brain is 80% Lyrics',            img: '"My Brain is 80% Lyrics" \u2013 Song Brain',                    sku: '4000999PIN_048' },
    { g: 'brain', label: 'Let Me Overthink This',             img: '"Let Me Overthink This" \u2013 Overthinker Mode',               sku: '4000999PIN_049' },
    { g: 'brain', label: 'Current Side Quest',                img: 'PIN_121_Current_Side_Quest',                                    sku: '4000999PIN_121' },
    { g: 'brain', label: "Don't Remember My Passwords",       img: '"Don\'t Remember My Passwords" \u2013 Password Brain Fog',     sku: '4000999PIN_074' },
    { g: 'brain', label: 'I May Look Calm',                   img: '"I May Look Calm" \u2013 Anxiety Masking',                      sku: '4000999PIN_019' },

    { g: 'chaotic', label: 'Chaos Certified',                  img: '"Chaos Certified" \u2013 Certified Chaos',                      sku: '4000999PIN_053' },
    { g: 'chaotic', label: 'Silly Goose Society Member',       img: '"Silly Goose Society Member" \u2013 Silly Goose Club',          sku: '4000999PIN_124' },
    { g: 'chaotic', label: "Dear Autocorrect It's Never Duck", img: '"Dear Autocorrect It\'s Never Duck" \u2013 Autocorrect Chaos',  sku: '4000999PIN_010' },
    { g: 'chaotic', label: 'On & Off Again',                   img: '"On & Off Again" \u2013 IT Crowd Humor',                        sku: '4000999PIN_094' },
    { g: 'chaotic', label: 'No Thoughts, Only Potato',         img: '"No Thoughts, Only Potato" \u2013 Potato Brain',               sku: '4000999PIN_129' },
    { g: 'chaotic', label: 'Powered By Caffeine and Sarcasm',  img: '"Powered By Caffeine and Sarcasm" \u2013 Caffeine & Sarcasm',  sku: '4000999PIN_017' },
    { g: 'chaotic', label: 'T-rex Clap',                       img: 'T-rex Clap \u2013 Short Arms Struggle',                         sku: '4000999PIN_035' },
    { g: 'chaotic', label: 'I Have It All Together',           img: '"I Have It All Together" \u2013 Hot Mess Energy',              sku: '4000999PIN_078' },

    { g: 'soft', label: 'Tolerate Toast',                      img: '"Tolerate Toast" \u2013 Celiac Humor',                           sku: '4000999PIN_003' },
    { g: 'soft', label: 'Sarcastic Sunshine',                  img: '"Sarcastic Sunshine" \u2013 Witty Mood',                         sku: '4000999PIN_005' },
    { g: 'soft', label: 'Kind Heart, Brave Spirit, Fierce Mind', img: '"Kind Heart, Brave Spirit, Fierce Mind" \u2013 Fierce & Kind', sku: '4000999PIN_043' },
    { g: 'soft', label: 'Silently Correcting Your Grammar',    img: '"Silently Correcting Your Grammar" \u2013 Grammar Police',      sku: '4000999PIN_116' },
    { g: 'soft', label: 'You Can Talk to Me',                  img: '"You Can Talk to Me" \u2013 Safe Space',                        sku: '4000999PIN_014' },
    { g: 'soft', label: 'Born To Sparkle, But Not Today',      img: '"Born To Sparkle, But Not Today" \u2013 Selective Sparkle',    sku: '4000999PIN_059' },
    { g: 'soft', label: 'Believe in Yourself',                 img: '"Believe in Yourself" \u2013 Daily Reminder',                  sku: '4000999PIN_028' },
    { g: 'soft', label: 'Be the person that your dog thinks you are', img: '"Be the person that your dog thinks you are" \u2013 Dog Parent Truth', sku: '4000999PIN_119' },

    { g: 'neurospicy', label: 'Older Than The Internet',            img: '"Older Than The Internet" \u2013 Pre-Internet Survivor',      sku: '4000999PIN_082' },
    { g: 'neurospicy', label: 'A touch of the tism',               img: '"A touch of the tism" \u2013 Autism Humor',                  sku: '4000999PIN_054' },
    { g: 'neurospicy', label: "Okay, I'm here. Where is the work?", img: '"Okay, I\'m here. Where is the work?" \u2013 Late to Work', sku: '4000999PIN_112' },
    { g: 'neurospicy', label: 'Allegedly',                          img: '"Allegedly" \u2013 Plausible Deniability',                   sku: '4000999PIN_128' },
    { g: 'neurospicy', label: 'Survived Meetings',                  img: '"Survived Meetings" \u2013 Office Survivor',                 sku: '4000999PIN_009' },
    { g: 'neurospicy', label: 'Everything is Figureoutable',        img: '"Everything is Figureoutable" \u2013 Solution Mindset',     sku: '4000999PIN_137' },
    { g: 'neurospicy', label: "Please be patient, I'm from the 1900s", img: '"Please be patient, I\'m from the 1900s" \u2013 Gen X Energy', sku: '4000999PIN_151' },
  ];

  // ── STI DATA ─────────────────────────────────────────────────
  var STI_DATA = [
    { label: 'Could Be Water, Could Be Vodka',       img: '"Could Be Water, Could Be Vodka" \u2013 Emotional Support Bottle', sku: '7000999STI_001' },
    { label: 'Oh Look, Nobody Gives A Shit',          img: '"Oh Look, Nobody Gives A Shit" \u2013 Zero F\'s Given',             sku: '7000999STI_004' },
    { label: "Didn't Lose My Shit Today",             img: '"Didn\'t Lose My Shit Today" \u2013 Daily Coping Win',             sku: '7000999STI_005' },
    { label: 'That Wasn\'t Very DATA-DRIVEN of You',  img: '"That Wasn\'t Very DATA-DRIVEN of You" \u2013 Data-Driven Shade', sku: '7000999STI_006' },
    { label: "Okay, I'm Here. Where's The Work",     img: '"Okay, I\'m Here. Where\'s The Work" \u2013 Late Arrival Mood',   sku: '7000999STI_007' },
    // Out of stock
    // { label: 'I Tolerate A Lot Of Shit, Not Dairy',  img: '"I Tolerate A Lot Of Shit, Just Not Dairy" \u2013 Dairy-Free Solidarity', sku: '7000999STI_008' },
    { label: 'Current Side Quest',                    img: '"Current Side Quest" \u2013 ADHD Side Quest',                     sku: '7000999STI_009' },
    { label: "Undiagnosed But Something Ain't Right", img: '"Undiagnosed But Something Ain\'t Right" \u2013 Undiagnosed Vibes', sku: '7000999STI_010' },
    { label: 'Emotional Support Coworker',            img: '"Emotional Support Coworker" \u2013 Workplace Solidarity',        sku: '7000999STI_011' },
    { label: 'I Came I Saw I Forgot',                 img: '"I Came I Saw I Forgot" \u2013 ADHD Memory Lapse',               sku: '7000999STI_012' },
    // Out of stock
    // { label: 'Certified Yapper',                      img: '"Certified Yapper" \u2013 Verbal Chaos Confirmed',               sku: '7000999STI_013' },
    { label: "Let's Handle This Like Adults",         img: '"Let\'s Handle This Like Adults" \u2013 Adults? Allegedly',      sku: '7000999STI_014' },
    { label: 'Just About McFuckin Had It',            img: '"Just About McFuckin Had It" \u2013 At the Limit',              sku: '7000999STI_017' },
    { label: 'I tolerate a lot of things not gluten', img: '"I tolerate a lot of things but not gluten" \u2013 Gluten-Free Solidarity', sku: '7000999STI_018' },
    { label: 'Dear Autocorrect, It is never DUCK',    img: '"Dear Autocorrect, It is never DUCK" \u2013 Autocorrect Chaos', sku: '7000999STI_019' },
    { label: 'Daily Shitstorm Survivors Club',        img: '"Daily Shitstorm Survivors Club" \u2013 Daily Chaos Survivor',  sku: '7000999STI_098' },
  ];

  // ── Image map (inline, from bundle_image_map.json) ───────────
  var PIN_IMG = {};
  var STI_IMG = {};
  PIN_DATA.forEach(function(p) { PIN_IMG[p.sku] = p.img; });
  STI_DATA.forEach(function(s) { STI_IMG[s.sku] = s.img; });

  // Full CDN map — key = the "img" label string
  var CDN = {
    '"Society of Badass Women" \u2013 Women\'s Solidarity': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/038_e75de7d1-c122-4df1-af57-9d5eda10c7c1.png?v=1779013589',
    '"Daily Shitstorm Survivors Club" \u2013 Daily Chaos Survivor': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/098_7a613b59-81db-41d0-b07f-bfe6df49496e.png?v=1779013696',
    '"OH, LOOK! NOBODY GIVES A SHIT" \u2013 Zero F\'s Given': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/136_a86f7321-09e3-4319-acef-42e72fdb3eb1.png?v=1779013789',
    '"Just About McFuckin Had It" \u2013 At the Limit': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/127_bd07a74a-b51f-4046-8835-211a67cea193.png?v=1779013762',
    '"SHENANIGAN ENTHUSIAST" \u2013 Mood Badge': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/147_e97c21be-3c77-47a9-81d0-cb3b6df72d2c.png?v=1779014607',
    '"Didn\'t Lose My Sh*t Today" \u2013 Coping Win': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/023_4e8713b6-b08b-4bc4-aa24-f8748aa7021b.png?v=1779013553',
    '"I Tried" \u2013 Low Effort Win': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/052.png?v=1779013615',
    '"Gotta Be Dramatic First" \u2013 Drama Energy': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/030_567dee6f-9c6e-4f4c-968a-b2b380611813.png?v=1779013569',
    '"Get Sh!t Done Club" \u2013 ADHD Productivity': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/064_8d7e182e-a2fb-4ed8-960b-9a7611939412.png?v=1779013634',
    '"Doom Pile" \u2013 Doom Stack Life': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/133_f5aba487-0f0b-4056-a151-42ac09af8108.png?v=1779013781',
    '"Easily Distracted by Shiny Things" \u2013 Shiny Thing Distraction': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/108_cf76bc6b-3a37-4ecf-b306-4f97ba3065a1.png?v=1779013718',
    '"Can You Repeat?" \u2013 Brain Fog': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/044_7d8343e3-2ea5-4e5e-8adb-3540317e4405.png?v=1779013599',
    '"My Brain is 80% Lyrics" \u2013 Song Brain': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/048_428ff203-08ac-44a1-8342-bc67bc7f17e9.png?v=1779013607',
    '"Let Me Overthink This" \u2013 Overthinker Mode': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/049_a330055b-c97c-467a-87b3-ebba9fc5590a.png?v=1779013610',
    '"Current Side Quest" \u2013 ADHD Side Quest': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/121_a01ae5bb-46b3-4b25-bd4f-a763faec86f5.png?v=1779013748',
    '"Don\'t Remember My Passwords" \u2013 Password Brain Fog': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/074_6ecff29e-08d9-497c-9f98-46718c8fd5b6.png?v=1779013652',
    '"I May Look Calm" \u2013 Anxiety Masking': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/019_6ddf3684-d3e1-40c5-8ff9-2a344a708f5a.png?v=1779013545',
    '"Chaos Certified" \u2013 Certified Chaos': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/053_897bd0a1-dd35-4cf1-923c-66c720dadc1c.png?v=1779013618',
    '"Silly Goose Society Member" \u2013 Silly Goose Club': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/124_d58ac518-81e4-4848-94a0-e8111c6c2346.png?v=1779013753',
    '"Dear Autocorrect It\'s Never Duck" \u2013 Autocorrect Chaos': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/010.png?v=1779013526',
    '"On & Off Again" \u2013 IT Crowd Humor': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/094_05611b57-25e8-4980-be4f-ca0ed2f94508.png?v=1779013688',
    '"No Thoughts, Only Potato" \u2013 Potato Brain': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/129_66206451-683c-44f0-be37-983fb3d27967.png?v=1779013769',
    '"Powered By Caffeine and Sarcasm" \u2013 Caffeine & Sarcasm': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/017_8a7379e8-ebbd-452b-8df0-86c168344cba.png?v=1779013542',
    'T-rex Clap \u2013 Short Arms Struggle': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/035_c1b500af-f539-4a01-8134-de7a94308624.png?v=1779013580',
    '"I Have It All Together" \u2013 Hot Mess Energy': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/078_5a631a44-3d15-43a5-8c33-4486302e31b8.png?v=1779014407',
    '"Tolerate Toast" \u2013 Celiac Humor': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/003_887fa2f6-de83-4bbc-a4df-cece32a3ef4c.png?v=1779013512',
    '"Sarcastic Sunshine" \u2013 Witty Mood': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/005_6718a547-0e67-44af-b93d-a1102e7aa355.png?v=1779013515',
    '"Kind Heart, Brave Spirit, Fierce Mind" \u2013 Fierce & Kind': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/043_767619b5-5307-4f5b-ba4c-6b9386b033a2.png?v=1779013597',
    '"Silently Correcting Your Grammar" \u2013 Grammar Police': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/116_4f0b68ae-dcf3-44f7-b3e9-31499fb6d512.png?v=1779013733',
    '"You Can Talk to Me" \u2013 Safe Space': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/014_63667374-f1df-4729-8dfd-08f85f75358e.png?v=1779013534',
    '"Born To Sparkle, But Not Today" \u2013 Selective Sparkle': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/059_712102ec-1861-4d80-bba3-87f243a657ea.png?v=1779013631',
    '"Believe in Yourself" \u2013 Daily Reminder': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/028_50ba0e17-ab41-4412-9b4b-358558f7b419.png?v=1779013564',
    '"Be the person that your dog thinks you are" \u2013 Dog Parent Truth': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/119_11b14021-4087-47dc-a3cd-f3e6c1d949dd.png?v=1779013742',
    '"Older Than The Internet" \u2013 Pre-Internet Survivor': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/082_7d83bf17-f915-4f05-8632-f5ecb48d35f8.png?v=1779013662',
    '"A touch of the tism" \u2013 Autism Humor': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/054_5254cc43-066d-4d45-b277-dbae537af444.png?v=1779013621',
    '"Okay, I\'m here. Where is the work?" \u2013 Late to Work': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/112_f8a7e38c-71f6-4a4a-a767-03d11f3226c5.png?v=1779013723',
    '"Allegedly" \u2013 Plausible Deniability': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/128_d85ad1a2-d180-4850-9c00-e87799fbe2bf.png?v=1779013765',
    '"Survived Meetings" \u2013 Office Survivor': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/009_9eabdd69-8085-42e4-9c05-23dec79b16c9.png?v=1779013524',
    '"Everything is Figureoutable" \u2013 Solution Mindset': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/137_3a03e585-3190-42b2-94c2-b156ebaf36eb.png?v=1779013792',
    '"Please be patient, I\'m from the 1900s" \u2013 Gen X Energy': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/151_72ea360d-e92e-4222-ba59-ebf6a1065400.png?v=1779013892',
    // STI CDN
    'PIN_098_Daily_Shitstorm': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/098_7a613b59-81db-41d0-b07f-bfe6df49496e.png?v=1779013696',
    'PIN_127_McFuckin': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/127_bd07a74a-b51f-4046-8835-211a67cea193.png?v=1779013762',
    'PIN_121_Current_Side_Quest': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/121_a01ae5bb-46b3-4b25-bd4f-a763faec86f5.png?v=1779013748',
    '"Could Be Water, Could Be Vodka" \u2013 Emotional Support Bottle': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI001_P1.png?v=1778940689',
    '"Oh Look, Nobody Gives A Shit" \u2013 Zero F\'s Given': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI004_P1.png?v=1778940682',
    '"Didn\'t Lose My Shit Today" \u2013 Daily Coping Win': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI005_P1.png?v=1778940823',
    '"That Wasn\'t Very DATA-DRIVEN of You" \u2013 Data-Driven Shade': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI006_P1.png?v=1778940660',
    '"Okay, I\'m Here. Where\'s The Work" \u2013 Late Arrival Mood': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI007_P1.png?v=1778940574',
    '"I Tolerate A Lot Of Shit, Just Not Dairy" \u2013 Dairy-Free Solidarity': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI008_P1.png?v=1778940899',
    '"Current Side Quest" \u2013 ADHD Side Quest': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI009_P1.png?v=1778940818',
    '"Undiagnosed But Something Ain\'t Right" \u2013 Undiagnosed Vibes': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI010_P1.png?v=1778940669',
    '"Emotional Support Coworker" \u2013 Workplace Solidarity': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI011_P1.png?v=1778940619',
    '"I Came I Saw I Forgot" \u2013 ADHD Memory Lapse': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI012A_P1.png?v=1778941205',
    '"Certified Yapper" \u2013 Verbal Chaos Confirmed': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI013_P1.png?v=1778940904',
    '"Let\'s Handle This Like Adults" \u2013 Adults? Allegedly': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI014_P1.png?v=1778940801',
    '"Please Leave me alone" \u2013 Introvert SOS': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI015_P1.png?v=1778940911',
    '"Please be nice to me" \u2013 Handle With Care': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI016_P1.png?v=1778940917',
    '"Just About McFuckin Had It" \u2013 At the Limit': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI017_P1mcfuckin.png?v=1778937511',
    '"I tolerate a lot of things but not gluten" \u2013 Gluten-Free Solidarity': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI018_P1.png?v=1778937444',
    '"Dear Autocorrect, It is never DUCK" \u2013 Autocorrect Chaos': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI019_P1.png?v=1778937362',
    '"Daily Shitstorm Survivors Club" \u2013 Daily Chaos Survivor': 'https://cdn.shopify.com/s/files/1/0876/1743/8010/files/STI098P1.png?v=1778940676',
  };

  function getImg(key) {
    return key && CDN[key] ? CDN[key] : null;
  }

  // ── State ─────────────────────────────────────────────────────
  var selectedPins = [];   // array of sku strings, max 6
  var selectedStis = [];   // array of sku strings, max 2
  var blindBox = true;
  var currentGroup = 'all';

  // ── Lightbox ──────────────────────────────────────────────────
  var lightbox = null;

  function initLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'mc-lightbox';
    lightbox.innerHTML = '<button class="mc-lightbox-close" style="position:absolute;top:16px;right:20px;color:#fff;font-size:2.2rem;background:none;border:none;cursor:pointer;padding:8px;min-width:44px;min-height:44px;line-height:1;z-index:10;">&times;</button><img src="" alt="" style="max-width:88vw;max-height:75vh;object-fit:contain;display:block;border-radius:12px;"><div class="mc-lightbox-label" style="position:absolute;bottom:32px;left:0;right:0;text-align:center;color:#fff;font-size:0.95rem;font-weight:600;padding:0 24px;"></div>';

    // Must be direct child of body to avoid stacking context issues on iOS
    document.body.appendChild(lightbox);

    function closeLightbox() {
      lightbox.classList.remove('active');
    }

    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox || e.target.classList.contains('mc-lightbox-close')) {
        closeLightbox();
      }
    });

    // Close on swipe down (mobile)
    var touchStartY = 0;
    lightbox.addEventListener('touchstart', function(e) {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    lightbox.addEventListener('touchend', function(e) {
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (dy > 60) closeLightbox(); // swipe down 60px = close
    }, { passive: true });
  }

  function openLightbox(imgSrc, label) {
    if (!lightbox) return;
    lightbox.querySelector('img').src = imgSrc;
    lightbox.querySelector('.mc-lightbox-label').textContent = label;
    lightbox.classList.add('active');
  }

  // ── Build PIN grid ────────────────────────────────────────────
  function buildPinGrid() {
    var grid = document.getElementById('pin-grid');
    if (!grid) return;
    grid.innerHTML = '';
    var filtered = currentGroup === 'all' ? PIN_DATA : PIN_DATA.filter(function(p) { return p.g === currentGroup; });
    filtered.forEach(function(pin) {
      var card = document.createElement('div');
      card.className = 'mc-card' + (selectedPins.indexOf(pin.sku) > -1 ? ' mc-selected' : '');
      card.dataset.sku = pin.sku;

      var imgUrl = getImg(pin.img);

      // Checkbox (top-right)
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = 'mc-card-cb';
      cb.checked = selectedPins.indexOf(pin.sku) > -1;
      cb.addEventListener('click', function(e) {
        e.stopPropagation();
        togglePin(pin.sku);
      });

      // Image wrap — click opens lightbox
      var imgWrap = document.createElement('div');
      imgWrap.className = 'mc-img-wrap';
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = pin.label;
        img.loading = 'lazy';
        img.onerror = function() { imgWrap.classList.add('mc-no-img'); };
        imgWrap.appendChild(img);
        // Tap vs scroll detection (Plan D)
        var touchStartX = 0, touchStartY = 0;
        imgWrap.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        var tapped = false;
        imgWrap.addEventListener('touchend', function(e) {
          var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
          var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
          if (dx > 8 || dy > 8) return; // scrolling — ignore
          tapped = true;
          e.preventDefault();
          e.stopPropagation();
          openLightbox(imgUrl, pin.label);
        }, { passive: false });
        imgWrap.addEventListener('click', function(e) {
          if (tapped) { tapped = false; return; }
          e.stopPropagation();
          openLightbox(imgUrl, pin.label);
        });
      } else {
        imgWrap.innerHTML = '<div class="mc-img-placeholder">🖤</div>';
      }

      // Label — click selects
      var label = document.createElement('span');
      label.className = 'mc-card-label';
      label.textContent = pin.label;
      label.addEventListener('click', function(e) {
        e.stopPropagation();
        togglePin(pin.sku);
      });

      card.appendChild(cb);
      card.appendChild(imgWrap);
      card.appendChild(label);
      // No card-level click — handled by cb + label individually
      grid.appendChild(card);
    });
  }

  function togglePin(sku) {
    var idx = selectedPins.indexOf(sku);
    if (idx > -1) {
      selectedPins.splice(idx, 1);
    } else {
      if (selectedPins.length >= 6) {
        shakeBtn();
        return;
      }
      selectedPins.push(sku);
    }
    updatePinUI();
  }

  function updatePinUI() {
    document.querySelectorAll('#pin-grid .mc-card').forEach(function(card) {
      var sku = card.dataset.sku;
      var selected = selectedPins.indexOf(sku) > -1;
      var cb = card.querySelector('.mc-card-cb');
      if (selected) {
        card.classList.add('mc-selected');
        if (cb) cb.checked = true;
      } else {
        card.classList.remove('mc-selected');
        if (cb) cb.checked = false;
        if (selectedPins.length >= 6) {
          card.classList.add('mc-disabled');
        } else {
          card.classList.remove('mc-disabled');
        }
      }
    });
    var counter = document.getElementById('pin-counter');
    if (counter) counter.textContent = selectedPins.length + ' / 6 selected';
    updateSummary();
    updateCTA();
  }

  // ── Build STI grid ────────────────────────────────────────────
  function buildStiGrid() {
    var grid = document.getElementById('sti-grid');
    if (!grid) return;
    grid.innerHTML = '';
    STI_DATA.forEach(function(sti) {
      var card = document.createElement('div');
      card.className = 'mc-card mc-sti-card' + (selectedStis.indexOf(sti.sku) > -1 ? ' mc-selected' : '') + (blindBox ? ' mc-sti-locked' : '');
      card.dataset.sku = sti.sku;

      var imgUrl = getImg(sti.img);

      // Checkbox
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = 'mc-card-cb';
      cb.checked = selectedStis.indexOf(sti.sku) > -1;
      cb.addEventListener('click', function(e) {
        e.stopPropagation();
        if (blindBox) return;
        toggleSti(sti.sku);
      });

      // Image wrap — click opens lightbox
      var imgWrap = document.createElement('div');
      imgWrap.className = 'mc-img-wrap';
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = sti.label;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
        var touchStartX2 = 0, touchStartY2 = 0;
        imgWrap.addEventListener('touchstart', function(e) {
          touchStartX2 = e.touches[0].clientX;
          touchStartY2 = e.touches[0].clientY;
        }, { passive: true });
        var tapped2 = false;
        imgWrap.addEventListener('touchend', function(e) {
          var dx = Math.abs(e.changedTouches[0].clientX - touchStartX2);
          var dy = Math.abs(e.changedTouches[0].clientY - touchStartY2);
          if (dx > 8 || dy > 8) return;
          tapped2 = true;
          e.preventDefault();
          e.stopPropagation();
          openLightbox(imgUrl, sti.label);
        }, { passive: false });
        imgWrap.addEventListener('click', function(e) {
          if (tapped2) { tapped2 = false; return; }
          e.stopPropagation();
          openLightbox(imgUrl, sti.label);
        });
      } else {
        imgWrap.innerHTML = '<div class="mc-img-placeholder">🎨</div>';
      }

      var labelEl = document.createElement('span');
      labelEl.className = 'mc-card-label';
      labelEl.textContent = sti.label;
      labelEl.addEventListener('click', function(e) {
        e.stopPropagation();
        if (blindBox) return;
        toggleSti(sti.sku);
      });

      card.appendChild(cb);
      card.appendChild(imgWrap);
      card.appendChild(labelEl);

      card.addEventListener('click', function() {
        if (blindBox) return;
        toggleSti(sti.sku);
      });
      grid.appendChild(card);
    });
  }

  function toggleSti(sku) {
    var idx = selectedStis.indexOf(sku);
    if (idx > -1) {
      selectedStis.splice(idx, 1);
    } else {
      if (selectedStis.length >= 2) { shakeBtn(); return; }
      selectedStis.push(sku);
    }
    updateStiUI();
  }

  function updateStiUI() {
    document.querySelectorAll('#sti-grid .mc-sti-card').forEach(function(card) {
      var sku = card.dataset.sku;
      var selected = selectedStis.indexOf(sku) > -1;
      card.classList.toggle('mc-selected', selected);
      card.classList.toggle('mc-disabled', !blindBox && selectedStis.length >= 2 && !selected);
      card.classList.toggle('mc-sti-locked', blindBox);
      var cb = card.querySelector('.mc-card-cb');
      if (cb) cb.checked = selected;
    });
    var counter = document.getElementById('sti-counter');
    if (counter) counter.textContent = blindBox ? 'Surprise Me! 🎁' : selectedStis.length + ' / 2 selected';
    updateSummary();
    updateCTA();
  }

  // ── Blind box toggle ──────────────────────────────────────────
  function initBlindBox() {
    var chk = document.getElementById('blindbox-check');
    if (!chk) return;
    chk.addEventListener('change', function() {
      blindBox = chk.checked;
      if (blindBox) selectedStis = [];
      updateStiUI();
    });
  }

  // ── Summary ───────────────────────────────────────────────────
  function updateSummary() {
    var pinList = document.getElementById('summary-pin-list');
    var stiList = document.getElementById('summary-sti-list');
    if (pinList) {
      pinList.textContent = selectedPins.length
        ? selectedPins.map(function(sku) {
            var p = PIN_DATA.find(function(x) { return x.sku === sku; });
            return p ? p.label : sku;
          }).join(', ')
        : 'None selected yet';
    }
    if (stiList) {
      if (blindBox) {
        stiList.textContent = 'Surprise me! \uD83C\uDF81';
      } else {
        stiList.textContent = selectedStis.length
          ? selectedStis.map(function(sku) {
              var s = STI_DATA.find(function(x) { return x.sku === sku; });
              return s ? s.label : sku;
            }).join(', ')
          : 'None selected yet';
      }
    }
  }

  // ── CTA ───────────────────────────────────────────────────────
  function updateCTA() {
    var btn = document.getElementById('mc-add-to-cart');
    if (!btn) return;
    var pinOk = selectedPins.length === 6;
    var stiOk = blindBox || selectedStis.length === 2;

    if (!pinOk) {
      btn.disabled = true;
      btn.textContent = 'Select ' + (6 - selectedPins.length) + ' more pin' + (6 - selectedPins.length !== 1 ? 's' : '') + ' to continue';
    } else if (!stiOk) {
      btn.disabled = true;
      btn.textContent = 'Select ' + (2 - selectedStis.length) + ' more sticker' + (2 - selectedStis.length !== 1 ? 's' : '');
    } else {
      btn.disabled = false;
      btn.textContent = 'Add Bundle to Cart \u2014 $31.99';
    }
  }

  function shakeBtn() {
    var btn = document.getElementById('mc-add-to-cart');
    if (!btn) return;
    btn.classList.add('mc-shake');
    setTimeout(function() { btn.classList.remove('mc-shake'); }, 500);
  }

  // ── Add to cart — single bundle SKU ──────────────────────────
  function initAddToCart() {
    var btn = document.getElementById('mc-add-to-cart');
    if (!btn) return;
    btn.addEventListener('click', function() {
      if (btn.disabled) return;

      var props = {};
      var variantIds = [];

      selectedPins.forEach(function(sku, i) {
        var p = PIN_DATA.find(function(x) { return x.sku === sku; });
        var v = ALL_VARIANTS.find(function(x) { return x.node.sku === sku })
        props['Pin ' + (i + 1)] = (p ? p.label : sku) + ' (' + sku + ')';
        if (v && v.node.id) variantIds.push(v.node.id);
      });

      if (blindBox) {
        props['Sticker 1'] = 'Surprise me';
        props['Sticker 2'] = 'Surprise me';
        variantIds.push(
          "gid://shopify/ProductVariant/53628954673466",
          "gid://shopify/ProductVariant/53628966109498")
      } else {
        selectedStis.forEach(function(sku, i) {
          var s = STI_DATA.find(function(x) { return x.sku === sku; });
          var v = ALL_VARIANTS.find(function(x) { return x.node.sku === sku })
          props['Sticker ' + (i + 1)] = (s ? s.label : sku) + ' (' + sku + ')';
          if (v && v.node.id) variantIds.push(v.node.id);
        });
      }

      props['_bundle_variant_ids'] = JSON.stringify(variantIds);

      btn.textContent = 'Adding\u2026';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: window.MC_BUNDLE_VARIANT_ID,
          quantity: 1,
          properties: props
        })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function() {
        btn.textContent = 'Error \u2014 please try again';
        btn.disabled = false;
      });
    });
  }

  // ── Tab filtering ─────────────────────────────────────────────
  function initTabs() {
    document.querySelectorAll('.mc-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        document.querySelectorAll('.mc-tab').forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        currentGroup = tab.dataset.group;
        buildPinGrid();
        updatePinUI();
        // CSS handles ratio — no JS resize needed
      });
    });
  }

  // ── Inject STI guidance note via JS (more reliable than body_html CSS) ──
  function injectStiNote() {
    var blindboxEl = document.getElementById('blindbox-option');
    if (!blindboxEl) return;
    // Remove any existing note to avoid duplicates
    var existing = document.getElementById('mc-sti-guidance');
    if (existing) existing.remove();
    var note = document.createElement('p');
    note.id = 'mc-sti-guidance';
    note.style.cssText = 'font-size:0.92rem;color:#1a1a1a;font-weight:600;margin-bottom:12px;margin-top:-6px;';
    note.textContent = 'Want to self-select? Uncheck the box below to browse all stickers and pick your favourites. Each slot = 1 unique sticker.';
    blindboxEl.parentNode.insertBefore(note, blindboxEl);
  }

  // ── hideNativeForm — no-op ────────────────────────────────────
  function hideNativeForm() {
    // Intentionally empty — to be implemented via Liquid template edit
  }

  // ── Fix Trust Bar, CTA button, Free shipping via DOM ─────────
  function fixUI() {
    // 0. Add "each slot = 1 unique pin" note under PIN section title
    var pinNote = document.getElementById('mc-pin-note');
    if (!pinNote) {
      var pinCounter = document.getElementById('pin-counter');
      if (pinCounter) {
        var pn = document.createElement('p');
        pn.id = 'mc-pin-note';
        pn.style.cssText = 'font-size:0.82rem;color:#555;margin:-8px 0 10px;';
        pn.textContent = 'Each slot = 1 unique pin.';
        pinCounter.closest('.mc-section-title').insertAdjacentElement('afterend', pn);
      }
    }

    // 0. Fix tabs — force nowrap via inline style (highest priority)
    var tabsEl = document.querySelector('.mc-tabs');
    if (tabsEl) {
      tabsEl.style.setProperty('flex-wrap', 'nowrap', 'important');
      tabsEl.style.setProperty('overflow-x', 'auto', 'important');
      tabsEl.style.setProperty('display', 'flex', 'important');
      tabsEl.style.webkitOverflowScrolling = 'touch';
    }
    document.querySelectorAll('.mc-tab').forEach(function(t) {
      t.style.setProperty('flex-shrink', '0', 'important');
      t.style.setProperty('white-space', 'nowrap', 'important');
    });

    // Image ratio handled purely by CSS (padding-bottom trick) — no JS needed

    // 0c. Hide Judge.me sidebar tab — specific ID only
    var jdgmBadge = document.getElementById('jdgm-widget');
    if (jdgmBadge) jdgmBadge.style.setProperty('display', 'none', 'important');

    // 1. Remove "637+ Reviews" trust item
    document.querySelectorAll('.mc-trust-item').forEach(function(el) {
      if (el.textContent.includes('637') || el.textContent.includes('Five-Star')) {
        el.remove();
      }
    });

    // 2. Fix free shipping note text
    document.querySelectorAll('.mc-cta-note').forEach(function(el) {
      if (el.textContent.includes('Free shipping')) {
        el.textContent = 'Free shipping on orders over $50 USD';
      }
    });

    // 3. Fix CTA button — override all conflicting styles inline
    var btn = document.getElementById('mc-add-to-cart');
    if (btn) {
      btn.style.cssText = [
        'background:#7B2FBE',
        'color:#fff',
        'border:none',
        'border-radius:8px',
        'font-size:1rem',
        'font-weight:700',
        'padding:14px 20px',
        'width:100%',
        'max-width:420px',
        'display:flex',
        'align-items:center',
        'justify-content:center',
        'text-align:center',
        'line-height:1.4',
        'white-space:normal',
        'word-break:break-word',
        'min-height:52px',
        'box-sizing:border-box',
        'cursor:pointer',
        'margin:0 auto',
        'text-transform:none',
        'letter-spacing:normal',
      ].join(';');
    }
  }

  // ── Init ──────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    initLightbox();
    buildPinGrid();
    buildStiGrid();
    initTabs();
    initBlindBox();
    initAddToCart();
    injectStiNote();
    updateCTA();
    hideNativeForm();
    fixUI();
    // Re-run after theme JS initialises
    setTimeout(function() { hideNativeForm(); fixUI(); }, 800);
    setTimeout(function() { hideNativeForm(); }, 2000);
  });

})();


/* ── Main image swap — confirmed selector: .product__section-images img ── */
(function () {
  var DEFAULT_SRC = window.MC_BUNDLE_DEFAULT_IMG || '';

  function swapMainImage(src) {
    // Primary confirmed selector for Foodie theme
    var imgs = document.querySelectorAll('.product__section-images img');
    if (!imgs.length) {
      // Fallback selectors
      imgs = document.querySelectorAll('.product-image-container img, .carousel-main img, .product__photo img');
    }
    imgs.forEach(function (img) {
      img.src = src;
      img.srcset = '';  // kill srcset so browser uses src
      // Update any zoom / lightbox data attrs
      ['data-zoom-src','data-large-image','data-src','data-full'].forEach(function(attr) {
        if (img.hasAttribute(attr)) img.setAttribute(attr, src);
      });
      // Walk up to figure/div and update their data attrs too
      var parent = img.parentElement;
      for (var i = 0; i < 4 && parent; i++) {
        ['data-zoom-src','data-large-image','data-src','data-full','href'].forEach(function(attr) {
          if (parent.hasAttribute && parent.hasAttribute(attr)) parent.setAttribute(attr, src);
        });
        parent = parent.parentElement;
      }
      // Also update <source> inside <picture>
      var picture = img.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function(s) { s.srcset = src; });
      }
    });
  }

  function getCardImgSrc(card) {
    var imgEl = card.querySelector('img');
    if (imgEl && imgEl.src && imgEl.naturalWidth > 0) {
      // Strip Shopify size suffix (_80x80, _200x200 etc) to get full-size
      return imgEl.src.replace(/_\d+x\d+(\.\w+)(\?|$)/, '$1$2');
    }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Set default on load
    if (DEFAULT_SRC) {
      setTimeout(function () { swapMainImage(DEFAULT_SRC); }, 600);
    }

    // PIN grid clicks
    var pinGrid = document.getElementById('pin-grid');
    if (pinGrid) {
      pinGrid.addEventListener('click', function (e) {
        var card = e.target.closest('.mc-card');
        if (!card) return;
        var src = getCardImgSrc(card);
        if (src) swapMainImage(src);
      });
    }

    // STI grid clicks
    var stiGrid = document.getElementById('sti-grid');
    if (stiGrid) {
      stiGrid.addEventListener('click', function (e) {
        var card = e.target.closest('.mc-card');
        if (!card || card.classList.contains('mc-sti-locked')) return;
        var src = getCardImgSrc(card);
        if (src) swapMainImage(src);
      });
    }
  });
})();
